// extracted by mini-css-extract-plugin
export default {"title":"d0niQ","actions":"fZPx3","action":"xU_ci"};